import { action, makeAutoObservable, observable } from "mobx";
var MarketDetailsStore = /** @class */ (function () {
    function MarketDetailsStore() {
        Object.defineProperty(this, "Intermediaries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "AdditionalInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        makeAutoObservable(this, {
            Intermediaries: observable,
            setIntermediaries: action,
            AdditionalInfo: observable,
            setAdditionalInfo: action
        });
    }
    Object.defineProperty(MarketDetailsStore.prototype, "setIntermediaries", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.Intermediaries = value;
        }
    });
    Object.defineProperty(MarketDetailsStore.prototype, "setAdditionalInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.AdditionalInfo = value;
        }
    });
    return MarketDetailsStore;
}());
export default MarketDetailsStore;
